module.exports = __webpack_public_path__ + "media/images/x-circle-1b125d888f70051736903813eb826d85.svg";